import {Box, Button, ChakraProps, useBreakpointValue} from '@chakra-ui/react';
import {HamburgerIcon} from '../../svg/HamburgerIcon';
import NiceModal from '@ebay/nice-modal-react';
import {CatalogueModale} from '@/domains/article/NomenclatureModale/CatalogueModale.js';
import {useTranslation} from 'react-i18next';

export interface ProductSection {
  id: number;
  title: string;
  img: string;
  categories?: {name: string; subcategories: string[]}[];
}

export const MenuCatalog: React.FC<{props?: ChakraProps}> = ({props}) => {
  const {t} = useTranslation();
  const viewMobile = useBreakpointValue({base: true, lg: false});

  return (
    <>
      <Box {...props}>
        <Button
          leftIcon={
            !viewMobile ? <HamburgerIcon color='blue.main' /> : undefined
          }
          variant='transparent'
          bg='transparent'
          borderColor='blue.main'
          borderWidth='1px'
          color='blue.main'
          _hover={{borderColor: 'gray.300'}}
          onClick={() => {
            NiceModal.show(CatalogueModale);
          }}
        >
          {!viewMobile ? (
            t('global.catalogue')
          ) : (
            <HamburgerIcon color='blue.main' />
          )}
        </Button>
      </Box>
    </>
  );
};
